// extracted by mini-css-extract-plugin
export default {"home":"Lists_home__EKltk","arrow":"Lists_arrow__YCLml","title":"Lists_title__ABabz","songs":"Lists_songs__Iidzk","link":"Lists_link__m-42s"};